<h2 mat-dialog-title>Nuevo candidato</h2>

<mat-dialog-content [formGroup]="form">
  <mat-button-toggle-group formControlName="user_link_mode" class="user-link-mode-toggle">
    <mat-button-toggle value="create">Crear usuario</mat-button-toggle>
    <mat-button-toggle value="link">Vincular existente</mat-button-toggle>
  </mat-button-toggle-group>

  @if (user_link_mode() === 'link') {
    <mat-form-field class="full-width">
      <mat-label>Buscar usuario candidato</mat-label>
      <input matInput type="text" formControlName="user_search" [matAutocomplete]="user_autocomplete" />
      @if (selected_linked_user()) {
        <button matSuffix mat-button type="button" (click)="clearLinkedUser()">Quitar</button>
      }
      <mat-autocomplete
        #user_autocomplete="matAutocomplete"
        [displayWith]="displayLinkedUserForAutocomplete"
        (optionSelected)="onLinkedUserSelected($event)"
      >
        @for (user of linked_users(); track user.id) {
          <mat-option [value]="user">{{ displayLinkedUserForAutocomplete(user) }}</mat-option>
        }
      </mat-autocomplete>
      <mat-hint>Mínimo 2 caracteres. Solo usuarios con rol candidato.</mat-hint>
    </mat-form-field>
  } @else {
    <div class="user-fields-grid">
      <mat-form-field class="full-width">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Apellidos</mat-label>
        <input matInput formControlName="surnames" />
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" />
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Teléfono</mat-label>
        <input matInput formControlName="phone" />
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Usuario de LinkedIn</mat-label>
        <input matInput formControlName="linkedin_username" placeholder="ej. nombre-apellido" />
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Ciudad</mat-label>
        <input matInput formControlName="city" />
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Sexo</mat-label>
        <mat-select formControlName="sex">
          <mat-option [value]="null">—</mat-option>
          <mat-option value="M">Masculino</mat-option>
          <mat-option value="F">Femenino</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  }

  <mat-form-field class="full-width">
    <mat-label>Notas</mat-label>
    <textarea matInput formControlName="notes" rows="3"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" [disabled]="loading() || !can_save()" (click)="save()">Guardar</button>
</mat-dialog-actions>
